import React from 'react'

import InlineReplenishmentPeriodEditField from './InlineReplenishmentPeriodEditField';
import InlineTextField from '../../components/InlineTextField';
import Switch from '../../components/Switch';
import ModuleDeleteButton from "../../components/ModuleDeleteButton"

const Module = (props) => {

    const showModulesArticles = () => {
        props.showModulesArticles(props.name);
    };

    const showModulesStores = () => {
        props.showModulesStores(props.name);
    };

    const handleContractChange = (contract) => {
        props.updateModuleContract(props.name, contract);
    };

    const handleAssortmentChange = (assortment) => {
        props.updateModuleAssortment(props.name, assortment);
    };

    const handleReplenishmentPeriodChange = (start, end) => {
        props.updateModuleReplenishmentPeriod(props.name, start, end);
    };

    return (
        <tr>
            <td>{props.name}</td>
            <td>
                <InlineReplenishmentPeriodEditField
                    startDate={props.startOfReplenishmentPeriod}
                    endDate={props.endOfReplenishmentPeriod}
                    onCommit={handleReplenishmentPeriodChange}/>
            </td>
            <td><InlineTextField value={props.contract} onCommit={handleContractChange}/></td>
            <td><InlineTextField value={props.assortment} onCommit={handleAssortmentChange}/></td>
            <td>
                <Switch value={props.unlimitedStock}
                        onActivate={() => props.activateUnlimitedStock(props.name)}
                        onDeactivate={() => props.deactivateUnlimitedStock(props.name)}/>
            </td>
            <td>
                <button className="btn btn-primary" onClick={showModulesArticles}>
                    <i className="icon-grid"/>&nbsp; Artikel
                </button>
                <button className="btn btn-primary" onClick={showModulesStores}>
                    <i className="icon-user-following"/>&nbsp; Stores
                </button>
                <ModuleDeleteButton deleteModule={props.deleteModule}
                                    name={props.name}/>

            </td>
        </tr>
    );
};

export default Module;



// WEBPACK FOOTER //
// ./src/admin/module/overview/Module.js